export default __webpack_public_path__ + "static/media/puente-lago-villarrica.ffa8fd91.jpeg";